import { useReveal } from "../hooks/useReveal";

export const About = ({ t }) => {
  const titleRef = useReveal();
  const textRef = useReveal();
  const pillarsRef = useReveal();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 sm:py-40 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Left column: Eyebrow + Title */}
          <div className="lg:col-span-5">
            <p className="text-[10px] uppercase tracking-[0.4em] text-white/50 mb-8">
              — {t.about.eyebrow} —
            </p>
            <h2
              ref={titleRef}
              data-testid="about-title"
              className="reveal heading-display text-4xl sm:text-5xl md:text-6xl whitespace-pre-line"
            >
              {t.about.title}
            </h2>
          </div>

          {/* Right column: Body text */}
          <div ref={textRef} className="reveal lg:col-span-7 lg:pt-2 space-y-6">
            <p className="text-base sm:text-lg leading-relaxed text-white/75">
              {t.about.p1}
            </p>
            <p className="text-base sm:text-lg leading-relaxed text-white/60">
              {t.about.p2}
            </p>
          </div>
        </div>

        {/* Pillars */}
        <div
          ref={pillarsRef}
          className="reveal mt-24 grid grid-cols-1 md:grid-cols-3 gap-px border border-white/10 rounded-2xl overflow-hidden bg-white/[0.02]"
          data-testid="about-pillars"
        >
          {t.about.pillars.map((pillar, idx) => (
            <div
              key={pillar.title}
              className="bg-[#070707] p-10 sm:p-12 group transition-colors hover:bg-[#0d0d0d]"
              data-testid={`about-pillar-${idx}`}
            >
              <div className="flex items-baseline gap-3 mb-6">
                <span className="text-[10px] tracking-[0.32em] text-white/40">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <span className="block flex-1 h-px bg-white/10" />
              </div>
              <h3 className="heading-display text-2xl sm:text-3xl mb-3">
                {pillar.title}
              </h3>
              <p className="text-sm text-white/55 leading-relaxed">{pillar.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
